var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossReportBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title3227"
  }, "duplicate-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title3227"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc3229"
  }, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3231"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect28075-4",
    style: {
      fill: "#464646",
      stroke: "none",
      strokeWidth: 1.0278
    },
    d: "m 23.96875,13.523437 v 2.741194 h 5.3125 v 3.631312 h -5.3125 v 2.705619 l -4.625,-4.525402 V 18.04315 Z M 8.0625,6.96875 V 9.709944 H 2.75 v 3.631312 h 5.3125 v 2.705619 l 4.625,-4.525402 v -0.03301 z M 13.841801,6.7525558 V 31.984977 h 10.746093 l 7.417969,-7.417969 V 6.7525558 Z m 1.65625,1.6582032 h 14.89453 v 15.046874 h -6.908203 v 6.828125 H 15.498051 Z M 0,0 V 25.232422 H 10.746094 L 13.34375,22.634766 V 16.705078 H 9.6425781 v 6.828125 H 1.65625 V 1.6582031 H 16.550781 V 6.3125 h 1.613281 V 0 Z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossReportBlack);
export default __webpack_public_path__ + "static/media/cross-report-black.94c8701fda1cb83fb08e44f076fba646.svg";
export { ForwardRef as ReactComponent };